import React, { useEffect, useState } from "react";
import "./button.css";

const Button = ({
  text,
  action,
  disabled,
  color = "blue",
  classNames = "",
  padding = false,
  fill = false,
  type = "button",
  isLoading = false,
  loadingText = "..."
}) => {
  const [colorState, setColorState] = useState("");
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    setColorState(disabled && color ? `${color}-light` : color);
  }, [color, disabled]);

  const handleClick = (event) => {
    if (type !== "submit") event.preventDefault(); // deja pasar submit al form
    if (action && !disabled && !isLoading) action();
  };

  const handleMouseEnter = () => {
    setColorState(!disabled && color ? `${color}-hard` : colorState);
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setColorState(disabled && color ? `${color}-light` : color);
    setIsHovered(false);
  };

  const finalText = isLoading ? loadingText : text;

  return (
    <button
      type={type}
      className={`fill-${fill
        ? colorState
        : !fill && isHovered
          ? colorState
          : `${disabled ? colorState : "White"}`
        } border-${!fill ? colorState : "none"} ${!padding ? "BigButton" : ""}
        quality-button ${classNames}`}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      disabled={disabled || isLoading}
    >
      <div className={`text-${fill || (!disabled && isHovered) ? "white" : colorState}`}>
        {finalText}
      </div>
    </button>
  );
};

export default Button;
